import { createContext, useState } from 'react';

import ApparelTypeData from './ApparelTypeData';

export const ApparelTypeStateContext = createContext();

const ApparelTypeContextProvider = ({ children }) => {
  const stateHook = useState(ApparelTypeData.INITIAL_APPAREL_TYPE_STATE);

  return (
    <ApparelTypeStateContext.Provider value={stateHook}>
      {children}
    </ApparelTypeStateContext.Provider>
  );
};

export default ApparelTypeContextProvider;